import { getAdminUrl } from './getAdminUrl';
import { getCurrentOrg } from '@api/getCurrentOrg';

type GetExternalConversationsUrlParams = {
  contactPhone?: string;
};

export const getExternalConversationsUrl = ({
  contactPhone,
}: GetExternalConversationsUrlParams) => {
  if (!contactPhone) return;
  const organization_id = getCurrentOrg();

  return `${getAdminUrl(false)}/conversation/${organization_id}?user_phone=${contactPhone}`;
};
